<template>
    <inertia-link :href="'/'">
        <img class="login-logo" src="../../img/toyota-admin-portal-logo.svg" alt="">
    </inertia-link>
</template>

<style>
    .login-logo {
        width: 100px;
        padding-bottom: 20px;
    }
</style>